import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import { publicationYearRange } from '../../utils/date';
import {map} from 'lodash';
import { getRelativePath } from '../../utils/url';

export default class ArchivesYearNav extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render = () => (
    <div className="module browse-by-years">
      <div className="browse-by-years-container">
        <RosettaFormattedMessage parentFilename={__filename}
          id="module_title"
          description="Appears above the year nav on the archives landing page"
          defaultMessage="A Blast From The Past"
        >
          {title => <h4 className="browse-by-years-nav-title" dangerouslySetInnerHTML={{ __html: title }} />}
        </RosettaFormattedMessage>
        <div id="archive-years">
          {
            map(publicationYearRange(this.context.edition_data.id), year => (
              <Link to={getRelativePath(`/archives/${year}`, this.context.edition_data)} key={year}>
                {year}
              </Link>
            ))
          }
        </div>
      </div>
    </div>
  )
}

ArchivesYearNav.contextTypes = {
  router: PropTypes.shape({
    push: PropTypes.func.isRequired
  }),
  edition_data: PropTypes.object
};
